"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfirmationOptions = exports.getLearnMoreConfig = exports.showOptout = exports.showOptin = exports.show = exports.isOptout = exports.isOptin = exports.canUserOptout = exports.canHubOptinFromOptout = exports.canHubOptout = exports.canUserOptin = exports.canHubOptin = exports.OPT_CHOICE_TO_TARGET_TYPE = exports.OPT_CHOICE_TO_STATE_VALUE = exports.isKnownState = exports.isHubWideChoice = exports.isOptedOut = exports.isOptedIn = exports.isAvailable = exports.OPT_CHOICE_REJECT = exports.OPT_CHOICE_HUB_OPT_OUT = exports.OPT_CHOICE_USER_OPT_OUT = exports.OPT_CHOICE_HUB_OPT_IN = exports.OPT_CHOICE_USER_OPT_IN = exports.OPT_STATE_UNAVAILABLE = exports.OPT_STATE_REJECTED = exports.OPT_STATE_OPTED_OUT = exports.OPT_STATE_OPTED_IN = exports.OPT_STATE_AVAILABLE = exports.isUserOptin = exports.isHubOptin = exports.TARGET_TYPE_USER = exports.TARGET_TYPE_HUB = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserState = require("./UserState");

var _OPT_CHOICE_TO_STATE_, _OPT_CHOICE_TO_TARGET;

var TARGET_TYPE_HUB = 'HUB';
exports.TARGET_TYPE_HUB = TARGET_TYPE_HUB;
var TARGET_TYPE_USER = 'USER';
exports.TARGET_TYPE_USER = TARGET_TYPE_USER;

var isHubOptin = function isHubOptin(targetType) {
  return targetType === TARGET_TYPE_HUB;
};

exports.isHubOptin = isHubOptin;

var isUserOptin = function isUserOptin(targetType) {
  return targetType === TARGET_TYPE_USER;
};

exports.isUserOptin = isUserOptin;
var OPT_STATE_AVAILABLE = 'AVAILABLE';
exports.OPT_STATE_AVAILABLE = OPT_STATE_AVAILABLE;
var OPT_STATE_OPTED_IN = 'OPTED_IN';
exports.OPT_STATE_OPTED_IN = OPT_STATE_OPTED_IN;
var OPT_STATE_OPTED_OUT = 'OPTED_OUT';
exports.OPT_STATE_OPTED_OUT = OPT_STATE_OPTED_OUT;
var OPT_STATE_REJECTED = 'REJECTED';
exports.OPT_STATE_REJECTED = OPT_STATE_REJECTED;
var OPT_STATE_UNAVAILABLE = 'UNAVAILABLE';
exports.OPT_STATE_UNAVAILABLE = OPT_STATE_UNAVAILABLE;
var OPT_CHOICE_USER_OPT_IN = 'USER_OPT_IN';
exports.OPT_CHOICE_USER_OPT_IN = OPT_CHOICE_USER_OPT_IN;
var OPT_CHOICE_HUB_OPT_IN = 'HUB_OPT_IN';
exports.OPT_CHOICE_HUB_OPT_IN = OPT_CHOICE_HUB_OPT_IN;
var OPT_CHOICE_USER_OPT_OUT = 'USER_OPT_OUT';
exports.OPT_CHOICE_USER_OPT_OUT = OPT_CHOICE_USER_OPT_OUT;
var OPT_CHOICE_HUB_OPT_OUT = 'HUB_OPT_OUT';
exports.OPT_CHOICE_HUB_OPT_OUT = OPT_CHOICE_HUB_OPT_OUT;
var OPT_CHOICE_REJECT = 'USER_REJECT';
exports.OPT_CHOICE_REJECT = OPT_CHOICE_REJECT;
var ALL_STATES = [OPT_STATE_AVAILABLE, OPT_STATE_OPTED_IN, OPT_STATE_OPTED_OUT, OPT_STATE_REJECTED, OPT_STATE_UNAVAILABLE, OPT_CHOICE_USER_OPT_IN, OPT_CHOICE_HUB_OPT_IN, OPT_CHOICE_USER_OPT_OUT, OPT_CHOICE_HUB_OPT_OUT, OPT_CHOICE_REJECT];

var isRejected = function isRejected(value) {
  return value === OPT_STATE_REJECTED || value === OPT_CHOICE_REJECT;
};

var isUnavailable = function isUnavailable(value) {
  return value === OPT_STATE_UNAVAILABLE;
};

var isAvailable = function isAvailable(value) {
  return value === OPT_STATE_AVAILABLE;
};

exports.isAvailable = isAvailable;

var isOptedIn = function isOptedIn(value) {
  return value === OPT_STATE_OPTED_IN || value === OPT_CHOICE_USER_OPT_IN || value === OPT_CHOICE_HUB_OPT_IN;
};

exports.isOptedIn = isOptedIn;

var isOptedOut = function isOptedOut(value) {
  return value === OPT_STATE_OPTED_OUT || value === OPT_CHOICE_USER_OPT_OUT || value === OPT_CHOICE_HUB_OPT_OUT;
};

exports.isOptedOut = isOptedOut;

var isHubWideChoice = function isHubWideChoice(choice) {
  return choice === OPT_CHOICE_HUB_OPT_IN || choice === OPT_CHOICE_HUB_OPT_OUT;
};

exports.isHubWideChoice = isHubWideChoice;

var isKnownState = function isKnownState(value) {
  return ALL_STATES.includes(value);
};

exports.isKnownState = isKnownState;
var OPT_CHOICE_TO_STATE_VALUE = (_OPT_CHOICE_TO_STATE_ = {}, (0, _defineProperty2.default)(_OPT_CHOICE_TO_STATE_, OPT_CHOICE_USER_OPT_IN, OPT_STATE_OPTED_IN), (0, _defineProperty2.default)(_OPT_CHOICE_TO_STATE_, OPT_CHOICE_HUB_OPT_IN, OPT_STATE_OPTED_IN), (0, _defineProperty2.default)(_OPT_CHOICE_TO_STATE_, OPT_CHOICE_USER_OPT_OUT, OPT_STATE_OPTED_OUT), (0, _defineProperty2.default)(_OPT_CHOICE_TO_STATE_, OPT_CHOICE_HUB_OPT_OUT, OPT_STATE_OPTED_OUT), (0, _defineProperty2.default)(_OPT_CHOICE_TO_STATE_, OPT_CHOICE_REJECT, OPT_STATE_REJECTED), _OPT_CHOICE_TO_STATE_);
exports.OPT_CHOICE_TO_STATE_VALUE = OPT_CHOICE_TO_STATE_VALUE;
var OPT_CHOICE_TO_TARGET_TYPE = (_OPT_CHOICE_TO_TARGET = {}, (0, _defineProperty2.default)(_OPT_CHOICE_TO_TARGET, OPT_CHOICE_USER_OPT_IN, TARGET_TYPE_USER), (0, _defineProperty2.default)(_OPT_CHOICE_TO_TARGET, OPT_CHOICE_HUB_OPT_IN, TARGET_TYPE_HUB), (0, _defineProperty2.default)(_OPT_CHOICE_TO_TARGET, OPT_CHOICE_USER_OPT_OUT, TARGET_TYPE_USER), (0, _defineProperty2.default)(_OPT_CHOICE_TO_TARGET, OPT_CHOICE_HUB_OPT_OUT, TARGET_TYPE_HUB), (0, _defineProperty2.default)(_OPT_CHOICE_TO_TARGET, OPT_CHOICE_REJECT, TARGET_TYPE_USER), _OPT_CHOICE_TO_TARGET);
exports.OPT_CHOICE_TO_TARGET_TYPE = OPT_CHOICE_TO_TARGET_TYPE;

var areActionsAllowed = function areActionsAllowed(_ref) {
  var actionsAllowed = _ref.actionsAllowed;
  return actionsAllowed;
};

var canHubOptin = function canHubOptin(_ref2) {
  var user = _ref2.user;
  return (0, _UserState.isSuperAdmin)(user);
};

exports.canHubOptin = canHubOptin;

var canUserOptin = function canUserOptin(_ref3) {
  var _ref3$availability = _ref3.availability,
      hubLevelOverride = _ref3$availability.hubLevelOverride,
      targetType = _ref3$availability.targetType;
  return isUserOptin(targetType) && !hubLevelOverride;
};

exports.canUserOptin = canUserOptin;

var canHubOptout = function canHubOptout(_ref4) {
  var user = _ref4.user,
      _ref4$availability = _ref4.availability,
      hubLevelOverride = _ref4$availability.hubLevelOverride,
      targetType = _ref4$availability.targetType;
  return (0, _UserState.isSuperAdmin)(user) && (isHubOptin(targetType) || isUserOptin(targetType) && hubLevelOverride);
};

exports.canHubOptout = canHubOptout;

var canHubOptinFromOptout = function canHubOptinFromOptout(_ref5) {
  var user = _ref5.user,
      _ref5$availability = _ref5.availability,
      hubLevelOverride = _ref5$availability.hubLevelOverride,
      targetType = _ref5$availability.targetType;
  return (0, _UserState.isSuperAdmin)(user) && isUserOptin(targetType) && !hubLevelOverride;
};

exports.canHubOptinFromOptout = canHubOptinFromOptout;

var canUserOptout = function canUserOptout(_ref6) {
  var _ref6$availability = _ref6.availability,
      hubLevelOverride = _ref6$availability.hubLevelOverride,
      targetType = _ref6$availability.targetType;
  return isUserOptin(targetType) && !hubLevelOverride;
};

exports.canUserOptout = canUserOptout;

var isOptin = function isOptin(_ref7) {
  var state = _ref7.state;
  return isAvailable(state) || isOptedOut(state);
};

exports.isOptin = isOptin;

var isOptout = function isOptout(_ref8) {
  var state = _ref8.state;
  return isOptedIn(state);
};

exports.isOptout = isOptout;

var show = function show(_ref9) {
  var state = _ref9.availability.state;
  return !isUnavailable(state) && !isRejected(state);
};

exports.show = show;

var showOptin = function showOptin(optSettings) {
  return isOptin(optSettings.availability) && areActionsAllowed(optSettings.availability) && !!(canHubOptin(optSettings) || canUserOptin(optSettings));
};

exports.showOptin = showOptin;

var showOptout = function showOptout(optSettings, _ref10) {
  var feedbackSurveyId = _ref10.feedbackSurveyId,
      learnMore = _ref10.learnMore;
  return isOptout(optSettings.availability) && areActionsAllowed(optSettings.availability) && !!(canHubOptout(optSettings) || canHubOptinFromOptout(optSettings) || canUserOptout(optSettings) || feedbackSurveyId || learnMore);
};

exports.showOptout = showOptout;

var getLearnMoreConfig = function getLearnMoreConfig(_ref11, learnMoreText) {
  var articleUrl = _ref11.availability.articleUrl;
  return articleUrl ? {
    text: learnMoreText,
    url: articleUrl
  } : undefined;
};

exports.getLearnMoreConfig = getLearnMoreConfig;

var getConfirmationOptions = function getConfirmationOptions(_ref12) {
  var choice = _ref12.opt.choice,
      OptInConfirmationModal = _ref12.OptInConfirmationModal,
      RejectConfirmationModal = _ref12.RejectConfirmationModal;

  if (isOptedIn(choice)) {
    return OptInConfirmationModal;
  }

  if (isRejected(choice)) {
    return RejectConfirmationModal;
  }

  return null;
};

exports.getConfirmationOptions = getConfirmationOptions;